import { ISupplyTimePattern } from "src/app/commons/ITypes";
import { Calendar, hasAllEmptyValues, isEmptyVal } from "src/app/commons/utils";
import { SupplyPatternDateSpecific } from "../types";
import * as moment from "moment";

export class SupplyRule {
  static validatePattern(patterns: Array<ISupplyTimePattern>) {
    const validPatterns = patterns.filter((item) => {
      return !(
        isEmptyVal(item.acceptOrder) ||
        isEmptyVal(item.lastCall) ||
        isEmptyVal(item.supplyTime)
      );
    });

    return {
      length: validPatterns.length,
      valid: validPatterns.length === 0 ? false : true,
    };
  }

  static validateDatePattern(patterns: Array<SupplyPatternDateSpecific>) {
    const validPatterns = patterns.filter((item) => {
      return !(isEmptyVal(item.lastCallDate) || isEmptyVal(item.supplyDate));
    });

    return {
      length: validPatterns.length,
      valid: validPatterns.length === 0 ? false : true,
    };
  }

  static sortPatterns(patterns = []) {
    return patterns.sort((a, b) => {
      if (a.acceptOrder === null && b.acceptOrder !== null) {
        return -1;
      } else if (a.acceptOrder !== null && b.acceptOrder === null) {
        return 1;
      } else if (a.acceptOrder !== null && b.acceptOrder !== null) {
        if (a.acceptOrder !== b.acceptOrder) {
          return a.acceptOrder - b.acceptOrder;
        }
      }

      if (!a.lastCall && b.lastCall) {
        return -1;
      } else if (a.lastCall && !b.lastCall) {
        return 1;
      } else if (a.lastCall && b.lastCall) {
        const lastCallA = Calendar.parse(
          a.lastCall,
          Calendar.formatType.hour24
        );
        const lastCallB = Calendar.parse(
          b.lastCall,
          Calendar.formatType.hour24
        );

        if (lastCallA.isBefore(lastCallB)) {
          return -1;
        } else if (lastCallA.isAfter(lastCallB)) {
          return 1;
        }
      }

      return 0;
    });
  }

  static sortDatePatterns(
    patterns: SupplyPatternDateSpecific[] = []
  ): SupplyPatternDateSpecific[] {
    return patterns.slice().sort((a, b) => {
      const getTimestamp = (item: SupplyPatternDateSpecific) => {
        if (!item || !item.lastCallDate) return Infinity;

        const time = item.lastCallTime ? item.lastCallTime : "00:00:00";
        const dateTime = moment(`${item.lastCallDate}T${time}`);

        return dateTime.isValid() ? dateTime.valueOf() : Infinity;
      };

      const aTime = getTimestamp(a);
      const bTime = getTimestamp(b);

      return aTime - bTime;
    });
  }

  static filterSortPatterns(patterns: Array<ISupplyTimePattern> = []) {
    const filteredPatterns = patterns.filter((item) => {
      return hasAllEmptyValues(item) ? false : true;
    });

    return this.sortPatterns(filteredPatterns);
  }

  static filterSortDatePatterns(
    patterns: Array<SupplyPatternDateSpecific> = []
  ) {
    const filteredPatterns = patterns.filter((item) => {
      return hasAllEmptyValues(item) ? false : true;
    });

    return this.sortDatePatterns(filteredPatterns);
  }
}
